import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/** 레거시 appr_sub_view_forms_groupsales 마크업(Bootstrap 클래스) 그대로라 태그·클래스로 스타일링 */
export const GroupSalesRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& > div + div': { marginTop: 8 },
  '& table': { ...approvalFormTableStyles(theme), minWidth: 640 },
  '& .text-center': { textAlign: 'center' },
  '& .text-left': { textAlign: 'left' },
  '& .text-right': { textAlign: 'right' },
  '& .group-sales-status': { color: theme.palette.warning.dark },
  '& tr.group-sales-history > td': {
    backgroundColor: 'var(--dk-warning-soft, #fff4e5)',
  },
  '& .group-sales-notice': {
    margin: '8px 0 0',
    color: theme.palette.error.main,
  },
}));
